import { Injectable } from '@angular/core';
import * as locale from 'locale-codes';
import { ILocale } from 'locale-codes';

const allowedLCID = [
  1033, // en-US
  12,   // fr
  7     // de
]

const languagePrefix: string = "global.locale"

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor() { }

  public get DefaultLocale(): ILocale {
    return locale.getByLCID(1033)
  }

  public get Locales(): Array<ILocale> {
    return locale.all
  }

  public get AllowedLocales(): Array<ILocale> {
    return this.Locales.filter(locale => allowedLCID.includes(locale.lcid))
  }

  public getLocaleName(locale: ILocale): string {
    return `${languagePrefix}.name.${locale.tag}`
  }

  public getLabel(): string {
    return `${languagePrefix}.label`
  }

  public getLocaleByTag(tag: string, allowedOnly: boolean = true): ILocale | undefined {
    const locales: Array<ILocale> = allowedOnly ? this.AllowedLocales : this.Locales
    return locales.find(locale => locale.tag === tag)
  }


}
